import { useTranslation } from 'react-i18next';

import { InfoWrapper, TitleWrapper, Wrapper } from './EmptyInternalNotes.styles';

import { Icon } from '@/components/Icon';

const ICON_SIZE = 24;

type Props = {
  studentName: string;
};

export const EmptyInternalNotes: React.FC<Props> = ({ studentName }) => {
  const { t } = useTranslation('ChatTranslations');

  return (
    <Wrapper>
      <Icon i="RequestQuote" size={ICON_SIZE} />
      <InfoWrapper>
        <TitleWrapper>{t('CREATE_A_NOTE')}</TitleWrapper>
        <div>{t('CREATE_FIRST_NOTE', { name: studentName })}</div>
      </InfoWrapper>
    </Wrapper>
  );
};
